import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import i18n from "@/core/plugins/i18n";

// app 初始化
import ApiService from "@/core/services/ApiService";
import { initVeeValidate } from "@/core/plugins/vee-validate";

const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);

// 全域注册 Element Plus 图示
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// Element Plus 主题（信赖蓝 #2563EB）＋ 全域样式 ＋ 组件精致化覆写
import "@/assets/element-variables.scss";
import "@/assets/app.scss";
import "@/assets/element-overrides.scss";

ApiService.init(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
